import { render, staticRenderFns } from "./InvoiceItem.vue?vue&type=template&id=6e60b041&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=js"
export * from "./InvoiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e60b041",
  null
  
)

export default component.exports